

















import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import Menu from './Menu/Menu.vue'

@Component({
  components: {Menu}
})
export default class Banner extends Vue {
  avatar = require('../assets/1.png')
}
